import { createSelector } from 'reselect'
import { selectPlans } from './selectPlans'
import { selectInboxProduct } from './selectInboxProduct'

export const selectCurrentInboxPlan = createSelector(
  selectInboxProduct,
  selectPlans,
  (product, plans) => {
    return plans.find(p => p.product === 'inbox' && p.planId === product.plan)
  }
)
